import { render, staticRenderFns } from "./dataDialog.vue?vue&type=template&id=efd163aa&scoped=true"
import script from "./dataDialog.vue?vue&type=script&lang=js"
export * from "./dataDialog.vue?vue&type=script&lang=js"
import style0 from "./dataDialog.vue?vue&type=style&index=0&id=efd163aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd163aa",
  null
  
)

export default component.exports